export const searchBoxText = "YDACue";
export const noResultsTitle = "B8y2D";
export const noResultsMessage = "WtFTFc";
export default {searchBoxText,noResultsTitle,noResultsMessage};